
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

// Events

window.Event = new Vue()

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { 
	  id: "G-R6H7MJC8E8", 
	  params: {
		  send_page_view: false,
	  }
	}
});


//router

import VueRouter from 'vue-router'
Vue.use(VueRouter)

let routes = [
  { path: '/novasenha', component: require('./components/Password.vue').default },
  { path: '/contatos', component: require('./components/Leads.vue').default },
  { path: '/usuarios', component: require('./components/Usuarios.vue').default },
  { path: '/sobre', component: require('./components/Sobre.vue').default },
  { path: '/precos/:tipo', component: require('./components/Precos.vue').default, props: true },
  { path: '*', component: require('./components/Leads.vue').default },
  
]

const router = new VueRouter({
	mode: 'history',
	routes
})


//filtros
Vue.filter('nivel_acesso',function(parm){
	var niveis = {
		'admin' : 'Administrador',
		'corretor' : 'Corretor'		
	};
	return niveis[parm];
});

Vue.filter('contato_lido',function(parm){
	if (parm=='sim') return "<span  title='Visto' class='btn btn-green btn-xs'><i class='fa fa-envelope-open'></i></span";
	return "<span class='btn btn-gray btn-xs' title='Não visto'><i class='fa fa-envelope'></i></span";
});

Vue.filter('valor',function(parm){

	if (parm==null) return "";

	var formatter = new Intl.NumberFormat('pt-BR', {
	  style: 'currency',
	  currency: 'BRL',
	  minimumFractionDigits: 2,	
	});	

	return formatter.format(parm);

});

Vue.filter('tipo',function(parm){
	if (parm=='imoveis') return "Imóveis";
	if (parm=='automoveis') return "Automóveis";
	return "Indefinido";
})

// var moment = require('moment');
import moment from 'moment';
moment.locale('pt-BR');
window.moment = moment;


Vue.filter('tempo_passado',function(parm){
	return moment(parm).fromNow();
});

Vue.filter('date_brl',function(parm){
  if (parm == null) return "";
  return moment(parm).format("DD/MM/Y");
})

Vue.filter('datetime_brl', function(parm){
	if (parm==null) return "";

	return moment(parm).format("DD/MM/Y HH:mm");
})

//masks
import VueMask from 'v-mask'
Vue.use(VueMask);

//v-money
import money from 'v-money'
Vue.use(money,{precision:2})

//sweet alert 2
import Swal from 'sweetalert2'
window.Swal = Swal;
//forms

import { Form, HasError, AlertError } from 'vform'

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)

window.Form = Form;

//select 2
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

//V-Stepper
import HorizontalStepper from 'vue-stepper';
Vue.component('horizontal-stepper',HorizontalStepper)
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('front-wrapper', require('./components/front/FrontWrapper.vue').default); 
Vue.component('simulador', require('./components/front/Simulador.vue').default); 
Vue.component('stepper', require('./components/front/Step.vue').default); 
Vue.component('simulador-passo-consorcio', require('./components/front/SimuladorPassoConsorcio.vue').default); 
Vue.component('simulador-passo-pessoais', require('./components/front/SimuladorPassoPessoais.vue').default); 
Vue.component('simulador-passo-resultado', require('./components/front/SimuladorPassoResultado.vue').default); 
Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('paginator', require('./components/Paginator.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({	
    router
}).$mount('#app');
